import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';

const LocationItem = ({
  id,
  name,
  address,
  city,
  state,
  zipCode,
  phone,
  certificationNumber,
  locationName,
  locationSearchResults,
  editing,
  saveable,
  selectable,
  onCancelClick,
  onCenterChange,
  onLocationNameChange,
  onRemoveClick,
  onSaveClick,
  onSearchClick 
}) => (
    editing
      ? 
      <div>
        <small className="form-group flex">Search by name, zip or certification #.  Name Requires minimum 3 characters.</small>
        <div>
          <Field
            classString="form-group flex"
            name="tournamentLocationName"
            type="input"
            component={StandardField}
            placeholder="Location Name"
            value={locationName}
            onCustomChange={event => onLocationNameChange(event.target.value)}
          />
          <Field
            classString="form-group flex"
            name="tournamentLocationZipCode"
            type="text"
            component={StandardField}
            placeholder="Zip Code"           
          />
          <Field
            classString="form-group flex"
            name="tournamentLocationCertificationNumber"
            type="text"
            component={StandardField}
            placeholder="Certification #"
          />
          {
            selectable 
              ?
              <Field
                name="tournamentLocationSearchResults"
                component={StandardSelectField}
                options={locationSearchResults}
                placeholder="Center"
                label="Centers"
                simpleValue
                searchable
                onCustomChange={onCenterChange}
              />
              :
              null
          }
        </div>
        <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-link"
            onClick={() => onCancelClick(id)}> {'Cancel'}
          </button>
          {' '}
          {
            saveable
              ? 
              <button 
                type="button"
                className="btn btn-primary btn-lg"
                onClick={() => onSaveClick(id)}>
                <i className="fa fa-search" /> {'Add Location'}
              </button>
              :
              <button 
                type="button"
                className="btn btn-primary btn-lg"
                onClick={() => onSearchClick(id)}>                  
                <i className="fa fa-search" /> {'Search'}                
              </button>
          }
        </div>
      </div>
      : 
      <div className="list-group-item-labeled">
        <div className="list-group-item-labeled-child">
          <b>{`${name}`}</b>
          {certificationNumber.toString().includes("-") ? null : `Certified #${certificationNumber}`}
          {certificationNumber.toString().includes("-") ? null : <br />}
          {address ? <span style={{ fontWeight: 300 }}>{address}<br /></span> : null}
          {city}, {state} {zipCode}
          {phone ? <span style={{ fontWeight: 300 }}>{phone}</span> : null}
        </div>
        <div className="list-group-item-labeled-child"
          style={{ flexDirection: 'row' }}>
          <button className="btn btn-link"
            type="button"
            onClick={() => onRemoveClick(certificationNumber)}>
            <i className="fa fa-times" /> {'Remove'}
          </button>
        </div>
      </div>
  );

LocationItem.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zipCode: PropTypes.string,
  certificationNumber: PropTypes.string,
  phone: PropTypes.string,
  locationName: PropTypes.string,
  locationSearchResults: PropTypes.arrayOf(PropTypes.object),
  editing: PropTypes.bool,
  saveable: PropTypes.bool,
  selectable: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onCenterChange: PropTypes.func,
  onLocationNameChange: PropTypes.func,
  onRemoveClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  onSearchClick: PropTypes.func
};

LocationItem.defaultProps = {
  locationName: '',
  editing: false,
  saveable: false,
  selectable: false
};

export default LocationItem;


// WEBPACK FOOTER //
// ./src/features/tournament/general/LocationItem.jsx